<template>
  <div class="app-container">
    <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :default-sort="defaultSort" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" :tooltip-config="{ contentMethod: false, enterable: true }" :selection="selection" @sort-change="sortChange" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.No')" prop="orderNo">
            <BjInput v-model="queryParams.orderNo" :placeholder="$t('InternalOrder.No')" comma @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('InternalOrder.order')">
            <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('InternalOrder.order')" />
          </el-form-item>
        </el-col>
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button v-if="!$store.getters.cusId" :disabled="tableOperationProp.notSelected" type="primary" class="main-btn" @click="betchPickup">{{ $t('InternalSalesOrderDetails.customerDelivery') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span>{{ scope.row.webReference }}</span>
                <BjCopyIcon :copy="scope.row.webReference" />
              </template>
              <template v-else-if="col.prop === 'totalOrderStatus'">
                <el-tag :type="scope.row[col.prop] === 7 ? 'success' : 'info'">{{
                  $t(ORDER_INTERNAL_ALL_STATUS_LIST.bjGet(scope.row[col.prop]))
                }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'orderHandleStatus'">
                {{ [0,6].includes(scope.row[col.prop]) ? $t(ORDER_WMS_STATUS_LIST.bjGet(scope.row[col.prop])) : ''}}
              </template>
              <template v-else-if="col.prop === 'orderStatusStr'">
                <el-tag :type="scope.row[col.prop] === 'Proccessing' ? 'success' : 'info'">{{ scope.row[col.prop] }}</el-tag>
              </template>
              <template v-else-if="col.prop === 'pickUpTime'">
                <span>{{ scope.row[col.prop] ? 'Yes' : '' }}</span>
              </template>
              <template v-else-if="col.prop === 'shippingMethod'">
                <el-tag>{{ $t(CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(scope.row[col.prop])) }}</el-tag>
              </template>

              <template v-else-if="col.prop === 'creationDate'">
                <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              </template>
              <template v-else-if="col.prop === 'failureReason'">
                {{ $t(LANG_ZH_EN_PS_LIST.bjGet(scope.row[col.prop])) }}
              </template>
              <template v-else-if="col.prop === 'orderTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'lastUpdateDate'">
                <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <!-- 跳内部详情页，不要 （取消，编辑）按钮，保留提货按钮 -->
              <el-button type="text" class="edit-btn" @click="toViewOrder(props.row)">{{ $t('viewText') }}</el-button>
              <el-button
                v-if="!$store.getters.cusId"
                type="text" class="main-btn" @click="customerDelivery(props.row)">{{ $t('InternalSalesOrderDetails.customerDelivery') }}
              </el-button>
              <el-button v-if="props.row.shippingMethod=='PICKUP'" :disabled="[0,6].includes(props.row.orderHandleStatus)" type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('cancelText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <delveryDialog ref="delveryDialogRef" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import delveryDialog from './delveryDialog';
import { orderApi } from '@/api';
import {
  CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST,
  ORDER_INTERNAL_HAND_UP_STATUS_LIST,
  ORDER_INTERNAL_ALL_STATUS_LIST,
  ORDER_WMS_STATUS_LIST,
  CSG_ORDER_SHIPPING_METHODS_LIST,
  LANG_ZH_EN_PS_LIST,
} from '@/utils/constants';
import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';

export default {
  name: 'BusinessAbnormalOrderCOLLECTPENDING',
  components: { delveryDialog, BjSelectCustomer },
  mixins: [pageMiXin],
  props: {},
  data() {
    return {
      selection: true,
      colSpan: 4,
      CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST,
      ORDER_INTERNAL_HAND_UP_STATUS_LIST,
      ORDER_INTERNAL_ALL_STATUS_LIST,
      ORDER_WMS_STATUS_LIST,
      CSG_ORDER_SHIPPING_METHODS_LIST,
      LANG_ZH_EN_PS_LIST,
      queryApi: orderApi.getCSGThirdOrderPage,
      // 查询参数
      queryParamsTime_order: [],
      queryParams: {
        cusId: null,
        channel: null,
        orderEndTime: null,
        orderNo: null,
        orderStartTime: null,
        storeId: null,
        shippingMethod: null,
        storeIdList: [],
        totalOrderStatus: [7],

        sortParam: null,
        sortOrder: null,

      },
      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: '190' },
        { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.Status'), prop: 'totalOrderStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.wmsStatus'), prop: 'orderHandleStatus', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false, width: '110'},
        { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false, width: '124'},
        { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('InternalOrder.form.document'), prop: 'logisticsNo', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Ordered'), prop: 'orderTime', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Created'), prop: 'creationDate', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.delivery'), prop: 'hjShipmentTime', isCheck: true, disabled: false, width: '165'},
        { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false, width: '180' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: '180' },
      ],
      defaultSort: [],
    };
  },
  computed: {
    labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
    },
  },
  watch: {
    queryParamsTime_order(v) {
      this.queryParams.orderStartTime = (v || [])[0];
      this.queryParams.orderEndTime = (v || [])[1];
    },
  },
  mounted() {
    this.$store.dispatch('values/getTags');
  },
  methods: {
    // 删除
    onDelete(item) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
      .then(() => {
        if(item.totalOrderStatus == 7&&item.shippingMethod=='PICKUP'){
          // 如果是处理中订单3，调用csg订单取消接口；
          orderApi.cancelInternalProccessingOrder({ innerOrderNo: item.innerOrderNo }).then(res => {
            if (res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        }
      })
    },
    sortChange (column) {
      switch (column.property) {
        case 'orderTime':
          this.queryParams.sortParam = column.property;
          this.queryParams.sortOrder = column.order;
          break;
        case 'creationDate':
          this.queryParams.sortParam = column.property;
          this.queryParams.sortOrder = column.order;
          break;
      }
      this.defaultSort = [{ field: column.field, order: column.order }];
      this.$refs.BjPage.fetchData();
    },
    // 跳转内部订单详情
    toViewOrder(item) {
      this.$router.push({
        name: 'BusinessOrderInternalViewCSG',
        query: { id: '', code: item.innerOrderNo, type: 'edit', status: item.totalOrderStatus || 7, orderHandleStatus: item.orderHandleStatus },
      });
    },
    // 批量提货
    betchPickup(){
      this.selectedRows.forEach(item=>{
        if(item.shippingMethod.toLowerCase().includes("csg manual") && (!item.logisticsNo || item.logisticsNo == ' ')){
          return this.$message.warning(this.$t('InternalOrder.ps2'));
        }
      })
      this.$refs.delveryDialogRef.selectedRows = this.selectedRows.map(e=>e.innerOrderNo);
      // 获取当前时间  
      const now = new Date();
      const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1); 
      this.$refs.delveryDialogRef.pickerOptions = {
        disabledDate(time) {
          // 如果选择的时间小于本周一的时间，则禁用
          if(new Date(item.receiveTime).getTime() > startOfWeek.getTime()){
            return time.getTime() < new Date(item.receiveTime).getTime();
          }else{
            return time.getTime() < startOfWeek.getTime();
          }
        },
      }
      this.$refs.delveryDialogRef.dialogVisible = true;
    },
    // 用户提货
    customerDelivery(item) {
      if(item.shippingMethod.toLowerCase().includes("csg manual") && (!item.logisticsNo || item.logisticsNo == ' ')){
        return this.$message.warning(this.$t('InternalOrder.ps2'));
      }
      this.$refs.delveryDialogRef.selectedRows = [item.innerOrderNo];
      // 获取当前时间  
      const now = new Date();
      const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1); 
      this.$refs.delveryDialogRef.pickerOptions = {
        disabledDate(time) {
          // 如果选择的时间小于本周一的时间，则禁用
          if(new Date(item.receiveTime).getTime() > startOfWeek.getTime()){
            return time.getTime() < new Date(item.receiveTime).getTime();
          }else{
            return time.getTime() < startOfWeek.getTime();
          }
        },
      }
      this.$refs.delveryDialogRef.dialogVisible = true;
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_order = null;
      this.queryParams.storeIdList = null;
      this.queryParams.cusId = null;
      this.queryParams.totalOrderStatus = [7];

      this.defaultSort = [];
      this.queryParams.sortParam = null;
      this.queryParams.sortOrder = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>

<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
